import { Branding, BrandingDisabledIf, DisabledPrompt, useModel, useRoute } from "bcms-react";
import Util from "classes/Util";
import { SVGAsset } from 'res';
import { MobileNavItem, MobileNavMenuItem, MobileNavDropdownMenuItem, MobileNavSubDropdownMenuItem } from "../..";

/**
 * @function BID2132PMobileNavItems
 * @extends React.Component
 * @exported true
 * @description The main component for navigation for BID 2132P in mobile.
 * @example
   <BID2132PMobileNavItems links={{
    profile: profileItem,
    settings: settingsItem
   }}/>
 */
export default function BID2132PMobileNavItems(props) {
  const { demos, branding } = useModel();
  const navigate = useRoute();
  const paymentsLabel = "Bill Pay";
  const items = props.items ?? {};
  const options = useModel().branding.options;

  const openAccount = evt => {
    if (Util.inMabi) {
      window.parent.postMessage({
        message: "force-global-route", detail: {
          route: `/content/orig`
        }
      }, "*");
    } else {
      let origVersion = branding.options.orig_version_abi22;
      if (origVersion !== "ORIG19") origVersion = "ORIG20";
      window.open(demos[origVersion], "_blank");
    }
  }

  const chatLink = () => {
    if (Util.inMabi) {
      Util.openMabiChat()
    }
    else {
      window.open(window.location.href.slice(0, window.location.href.indexOf("#")) + "#/chat", "_blank")
    }

  };

  const hasMultiProfileOptionOn = options.multiprofile_abi22 === "true";
  let changeProfilePath = `/changeProfile`;

  const newAccountsItem =
    <MobileNavDropdownMenuItem className="accounts-mobile-link" itemIcon={<SVGAsset id="WalletIcon" />} label="Accounts" dataPoint="Nav_Accounts">
      <MobileNavMenuItem className="account-summary-mobile-link" to="/accountSummary" label="Account Summary" dataPoint="Nav_Account_Summary" />
      {!Util.inMabi &&
        <MobileNavMenuItem className="statements-mobile-link" to="/statements" label="eStatements" dataPoint="Nav_eStatements_Noticies" />
      }
      {Util.inMabi &&
        <>
          <DisabledPrompt>
            <MobileNavMenuItem className="statements-mobile-link" label="eStatements" dataPoint="Nav_eStatements_Noticies" />
          </DisabledPrompt>
        </>
      }
      <DisabledPrompt>
        <MobileNavMenuItem className="mortgage-accounts-link" label="Mortgage Accounts" dataPoint="Nav_Mortgage_Accounts" />
      </DisabledPrompt>
      {!Util.inMabi &&
        <BrandingDisabledIf id="orig_courseid_abi22" exp={value => { return value !== null && value !== undefined; }}>
          <MobileNavMenuItem className="open-an-account-mobile-link" label="Open a New Account" dataPoint="Nav_Open_Account" onClick={openAccount} />
        </BrandingDisabledIf>
      }
      {Util.inMabi &&
        <>
          <DisabledPrompt>
            <MobileNavMenuItem className="open-an-account-mobile-link" label="Open a New Account" dataPoint="Nav_Open_Account" />
          </DisabledPrompt>
        </>
      }
      <MobileNavSubDropdownMenuItem label="Apply For" dataPoint="Nav_Pay_Loan">
        <DisabledPrompt>
          <MobileNavMenuItem className="apply-for-a-mortgage-mobile-link" label="Apply for a Mortgage" dataPoint="Nav_Apply_for_a_Mortgage" />
        </DisabledPrompt>
        <DisabledPrompt>
          <MobileNavMenuItem className="apply-for-a-loan-mobile-link" label="Apply for a Loan" dataPoint="Nav_Apply_for_a_Loan" />
        </DisabledPrompt>
        <DisabledPrompt>
          <MobileNavMenuItem className="apply-for-a-credit-card-mobile-link" label="Apply for a Credit Card" dataPoint="Nav_Apply_for_a_Credit_Card" />
        </DisabledPrompt>
      </MobileNavSubDropdownMenuItem>
      <DisabledPrompt>
        <MobileNavMenuItem className="relationship-builder-mobile-link" label="Relationship Builder" dataPoint="Nav_Relationship_Builder" />
      </DisabledPrompt>
      <DisabledPrompt>
        <MobileNavMenuItem className="commercial-banking-mobile-link" label="Commercial Banking" dataPoint="Nav_Commercial_Banking" />
      </DisabledPrompt>
      <DisabledPrompt>
        <MobileNavMenuItem className="fee-schedule-mobile-link" label="Fee Schedule" dataPoint="Nav_Fee_Schedule" />
      </DisabledPrompt>
    </MobileNavDropdownMenuItem>;

  const transfersItem =
    <MobileNavDropdownMenuItem className="transfer-mobile-link" itemIcon={<SVGAsset id="TransfersIcon" />} label="Transfers" dataPoint="Nav_Transfers">
      <MobileNavMenuItem className="make-a-transfer-mobile-link" to="/transfers" label="Make a Transfer" dataPoint="Nav_Make_Transfer" />
      <MobileNavMenuItem className="transfer-activity-mobile-link" to="/transferActivity/scheduledTransfers" label="Transfer Activity" dataPoint="Nav_Transfer_Activity" />
      <BrandingDisabledIf id="tn19_courseID_abi22" exp={value => value !== null}>
        <MobileNavMenuItem className="external-transfers-mobile-link" label="External Transfers" to="/externalTransfers" dataPoint="Nav_External_Transfers" />
      </BrandingDisabledIf>
      <MobileNavMenuItem className="other-nfcu-accounts-mobile-link" to="/unlinkedTransferAccounts" label="Other NFCU Accounts" dataPoint="Nav_Transfer_Accounts" />
      {!Util.inMabi &&
        <DisabledPrompt>
          <MobileNavMenuItem className="in-branch-transactions-mobile-link" label="In-Branch Transactions" dataPoint="Nav_In-Branch_Transactions" />
        </DisabledPrompt>
      }
    </MobileNavDropdownMenuItem>;

  const depositsItem = <>
    {Util.inMabi &&
      <>
        <MobileNavDropdownMenuItem className="deposits-mobile-link" itemIcon={<SVGAsset id="CameraIcon" />} label="Deposits" dataPoint="Nav_Deposits">
          <MobileNavMenuItem className="deposit-a-check-link" to="/depositACheckWorkflow" label="Deposit a Check" dataPoint="Nav_Deposit_A_Check" />
          <MobileNavMenuItem className="deposit-history-link" to="/depositHistory" label="Deposit History" dataPoint="Nav_Deposit_History" />
        </MobileNavDropdownMenuItem>
      </>
    }
  </>

  const paymentsItem =
    <MobileNavDropdownMenuItem className="payments-mobile-link" itemIcon={<SVGAsset id="DollarSignOutlineIcon" />} label="Payments" dataPoint="Nav_Payments">
      <MobileNavMenuItem className="bill-payment-center-mobile-link" to="/payments" label="Bill Payment Center" dataPoint="Nav_Payments" />
      <MobileNavSubDropdownMenuItem label="Loan Payment Center" dataPoint="Nav_Loan_Payment_Center">
        <DisabledPrompt>
          <MobileNavMenuItem className="pay-with-external-account-mobile-link" label="Pay with External Account" dataPoint="Nav_Pay_with_External_Account" />
        </DisabledPrompt>
        <MobileNavMenuItem className="transfers-mobile-link" to="/transfers" label="Pay with NFCU Account" dataPoint="Nav_Pay_with_NFCU_Account_Transfers" />
      </MobileNavSubDropdownMenuItem>
      <MobileNavMenuItem className="stop-payments-mobile-link" to="/stopPayment" label="Stop Payment" dataPoint="Nav_Stop_Payments" />
      <DisabledPrompt>
        <MobileNavMenuItem className="skip-a-payment-mobile-link" label="Skip A Payment" dataPoint="Nav_Skip_A_Payment" />
      </DisabledPrompt>
    </MobileNavDropdownMenuItem>;

  const cardItem = <>
    {Util.inMabi &&
      <>
        <BrandingDisabledIf id="ch21_courseid_abi22" exp={value => value !== undefined && value !== null}>
          <MobileNavItem className="ch21-mobile-link" itemIcon={<SVGAsset id="CardIcon" />} label="My Cards" to="/ch21" dataPoint="Nav_Debit_Card_Management" />
        </BrandingDisabledIf>
      </>
    }
  </>


  const myFinances =
    <BrandingDisabledIf id="pfm21_courseID_abi22" exp={value => value !== null} >
      <MobileNavItem className="pfm21-mobile-link" itemIcon={<SVGAsset id="PiggyBankDollarSignIcon" />} label="My Finances" to="/myFinances" dataPoint="Nav_My_Finances" />
    </BrandingDisabledIf>;



  const profileItem =
    <MobileNavDropdownMenuItem className="profile-mobile-link" itemIcon={<SVGAsset id="CircleProfileIcon" />} label="Profile" dataPoint="Nav_Profile">
      <MobileNavMenuItem className="contact-info-mobile-link" to="/actContactInfo" label="Contact Information" dataPoint="Nav_Contact_Information" />
      <MobileNavMenuItem className="user-id-mobile-link" label="User ID" to="/userId" dataPoint="Nav_User_ID" />
      <MobileNavMenuItem className="password-mobile-link" to="/password" label="Password" dataPoint="Nav_Password" />
      <DisabledPrompt>
        <MobileNavMenuItem className="profile-picture-mobile-link" label="Profile Picture" dataPoint="Nav_Profile_Picture" />
      </DisabledPrompt>
      <MobileNavMenuItem className="secure-forms-mobile-link" to="/secureForms" label="Secure Forms" dataPoint="Nav_Secure_Forms" />
      {!Util.inMabi &&
        <MobileNavMenuItem className="user-activity-mobile-link" to="/userActivityWorkflow" label="User Activity" dataPoint="Nav_User_Activity" />
      }
      <MobileNavMenuItem className="accepted-disclosures-mobile-link" to="/acceptedDisclosuresWorkflow" label="Accepted Disclosures" dataPoint="Nav_Accepted_Disclosures" />
      {Util.inMabi &&
        <DisabledPrompt>
          <MobileNavMenuItem className="delete-an-account-mobile-link" to="/deleteanaccount" label="Delete an Account" dataPoint="Utility_Delete_Account" />
        </DisabledPrompt>
      }

    </MobileNavDropdownMenuItem>;


  const settingsItem =
    <MobileNavDropdownMenuItem className="settings-mobile-link" itemIcon={<SVGAsset id="GearIcon" />} label="Settings" dataPoint="Utility_Settings">
      <DisabledPrompt>
        <MobileNavMenuItem className="alerts-mobile-link" label="Alerts" dataPoint="Utility_Alerts" />
      </DisabledPrompt>
      {Util.inMabi &&
                        <MobileNavMenuItem className="face-touch-id-mobile-link" to="/authorizedDeviceEnrollmentWorkflow" label="Biometric Enrollment" dataPoint="Utility_Authorized_Device_Enrollment" />
                        }
      <MobileNavMenuItem className="face-touch-id-mobile-link" to="/authorizedDevicesWorkflow" label="Biometric Devices" dataPoint="Nav_Authorized_Devices" />
      <MobileNavMenuItem className="fast-balances-mobile-link" to="/settingsFastBalancesWorkflow" label="Fast Balances" dataPoint="Utility_Instance_Balances" />
      <MobileNavMenuItem className="text-banking-mobile-link" to="/textBanking" label="Text Banking" dataPoint="Nav_Text_Banking" />
      <MobileNavMenuItem className="authorized-apps-mobile-link" to="/authorizedApps" label="Authorized Apps" dataPoint="Utility_Authorized_Apps" />
    </MobileNavDropdownMenuItem>;

  const utilityNavItems =
    <>
    {Util.inMabi && 
    <>
      <MobileNavItem className="chat-mobile-link" onClick={chatLink} label="Chat" itemIcon={<SVGAsset id="ChatIcon" />} dataPoint="Nav_Chat" />
      <MobileNavItem className="messages-mobile-link" to="/messages" label="Messages" itemIcon={<SVGAsset id="EnvelopeIcon" />} dataPoint="Nav_Messages">
        <div className="set-width alert-bubble flex-container all-center">
          <span>3</span>
        </div>
      </MobileNavItem>
      <DisabledPrompt>
        <MobileNavItem className="schedule-an-appointment-mobile-link" label="Schedule An Appointment" itemIcon={<SVGAsset id="CalendarIcon" />} dataPoint="Nav_Schedule_An_Appointment" />
      </DisabledPrompt>
      <MobileNavItem className="zle-mobile-link" itemIcon={<SVGAsset id="ZelleIcon" />} to={hasMultiProfileOptionOn ? changeProfilePath : "/zelle"} label={<>Send Money with Zelle<span className="r-mark">&reg;</span></>} dataPoint="Nav_Zelle" />
      <DisabledPrompt>
        <MobileNavItem className="help-mobile-link" label="Help" itemIcon={<SVGAsset id="QuestionMarkCircleIcon" />} dataPoint="Nav_Help" />
      </DisabledPrompt>
      </>
    }
    {!Util.inMabi && 
    <>
      <MobileNavItem className="messages-mobile-link" to="/messages" label="Messages" itemIcon={<SVGAsset id="EnvelopeIcon" />} dataPoint="Nav_Messages">
        <div className="set-width alert-bubble flex-container all-center">
          <span>3</span>
        </div>
      </MobileNavItem>
      <MobileNavItem className="zle-mobile-link" itemIcon={<SVGAsset id="ZelleIcon" />} to={hasMultiProfileOptionOn ? changeProfilePath : "/zelle"} label={<>Send Money with Zelle<span className="r-mark">&reg;</span></>} dataPoint="Nav_Zelle" />
      <DisabledPrompt>
        <MobileNavItem className="help-mobile-link" label="Help" itemIcon={<SVGAsset id="QuestionMarkCircleIcon" />} dataPoint="Nav_Help" />
      </DisabledPrompt>
      <MobileNavItem className="chat-mobile-link" onClick={chatLink} label="Chat" itemIcon={<SVGAsset id="ChatIcon" />} dataPoint="Nav_Chat" />
      <DisabledPrompt>
        <MobileNavItem className="schedule-an-appointment-mobile-link" label="Schedule An Appointment" itemIcon={<SVGAsset id="CalendarIcon" />} dataPoint="Nav_Schedule_An_Appointment" />
      </DisabledPrompt>
      </>
    }
    </>

  return (
    <Branding id="bid_abi22" value="2132P" >
      {newAccountsItem}
      {transfersItem}
      {depositsItem}
      {paymentsItem}
      {cardItem}
      {myFinances}
      {profileItem}
      {settingsItem}
      {utilityNavItems}
    </Branding>
  );
}

